<template>
	<div v-if="hasPower(power)" style="display: none;"><slot></slot></div>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		props: {
			power: String
		},
		
		computed: {
			...mapGetters({
				hasPower: 'power'
			})
		}
	};
</script>